
<a target="_self" [routerLink]="[]"  (click)="onClick()">{{ name }}</a>